export const countDownCreate = (id, initialTime, autoStart = true, autoStop = true) => ({
  type: 'COUNT_DOWN_CREATE', id, initialTime, autoStart, autoStop
});

export const downCountDownCreate = (id, initialTime, autoStart = true, autoStop = true) => ({
  type: 'DOWN_COUNT_DOWN_CREATE', id, initialTime, autoStart, autoStop,
  meta: {sendClient: true}
});

export const countDownTimeout = (id) => ({
  type: 'COUNT_DOWN_TIMEOUT', id
});

export const countDownSetStatus = (id, status) => ({
  type: 'COUNT_DOWN_SET_STATUS', id, status,
});

export const downCountDownSetStatus = (id, status) => ({
  type: 'DOWN_COUNT_DOWN_SET_STATUS', id, status,
  meta:{sendClient:true}
});

export const openCountDownFullscreen = (id) => ({
  type: 'OPEN_COUNT_DOWN_FULLSCREEN', id,
});

export const closeCountDownFullscreen = () => ({
  type: 'CLOSE_COUNT_DOWN_FULLSCREEN',
});